module.exports = __webpack_public_path__ + "order/img/NN.765e1e9c.svg";